// src/index.js
//
// This is the actual starting point of the React app. react-scripts
// looks for this exact file. It takes the <App /> component (which has
// all our routing/pages inside it) and mounts it into the <div id="root">
// that's sitting in public/index.html.

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
